/**
 * Generated runtime TestId mirror for frontend/src/pages/AccessRequestWizard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AccessRequestWizardTestIds = {
  accessProfileAssociationEditor: "access-profile-association-editor",
  accessRequestStepContainer: "access-request-step-container",
  accessRequestWizardPage: "access-request-wizard-page",
  beneficiaryCapMessage: "beneficiary-cap-message",
  beneficiaryCounter: "beneficiary-counter",
  beneficiaryMultiPicker: "beneficiary-multi-picker",
  btnCancel: "btn-cancel",
  btnNextStep: "btn-next-step",
  btnPreviousStep: "btn-previous-step",
  btnSelectMyself: "btn-select-myself",
  btnSelectSomeoneElse: "btn-select-someone-else",
  btnSubmitRequest: "btn-submit-request",
  cardTitleReviewAndSubmit: "card-title-review-and-submit",
  cardTitleSelectAccessProfiles: "card-title-select-access-profiles",
  cardTitleWhoNeedsAccess: "card-title-who-needs-access",
  reviewBeneficiaryChips: "review-beneficiary-chips",
  reviewExpansionSummary: "review-expansion-summary",
  reviewProfileItem: "review-profile-item",
  expirationDate: (item_profile_id: string) => `expiration-date-${item_profile_id}`,
  expirationDatePrefix: () => "expiration-date-" as TestIdPrefix,
  holdingStatus: (item_profile_id: string) => `holding-status-${item_profile_id}`,
  holdingStatusPrefix: () => "holding-status-" as TestIdPrefix,
  reviewBeneficiary: (b_id: string) => `review-beneficiary-${b_id}`,
  reviewBeneficiaryPrefix: () => "review-beneficiary-" as TestIdPrefix
} as const;
